import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import swal from 'sweetalert'
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getConfig, numberFormat, checkToken } from '../../../../../redux/config/config';
import { makeStyles } from '@material-ui/styles';
// import TextField from '@material-ui/core/TextField';

import {
  Card,
  CardActions,
  CardContent,
  Avatar,
  Checkbox,
  Table,
  TextField,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button,
  Dialog,
  Grid,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Slide,
  CircularProgress
} from '@material-ui/core';
import {Link} from 'react-router-dom';

import { getInitials } from 'helpers';
import Paginate from '../../Users/UsersTable/paginate';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  bash:{
    width: 1020
  },
  formLabel: {
    alignItems: 'center',
    paddingLeft:10,
    paddingTop:15
  },
  formLabels: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '25ch',
    alignItems: 'right'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const UsersTable = props => {
  const { className, loading, users, reversePosting, type, ...rest } = props;
  const classes = useStyles();

  const handleReverse = (id) => {
    swal({
      title: "Are you sure",
      text: "You want to reverse this posting?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        console.log(id)
        props.reversePosting(id);
        swal("Loading...",{   
          buttons:false
        });
      }
    });
    }

  return (
    <Card className={clsx(classes.root, className)} >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            {type === "shareholding"?
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Total Balance</TableCell>
                  <TableCell>Payment Method</TableCell>
                  <TableCell>Start Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {loading?
              <TableRow><TableCell><CircularProgress /></TableCell></TableRow>:
              users && users.length !== 0 ?
              users.map(user => (
                <TableRow
                  className={classes.tableRow}
                  hover
                  key={user.id}>
                  <TableCell>
                    <div className={classes.nameContainer}>
                      <Avatar
                        className={classes.avatar}
                        src={user.profile_pic}
                      >
                        {getInitials(user.first_name)}
                      </Avatar>
                      <Typography variant="body1">{user.first_name}{' '}{user.last_name}</Typography>
                    </div>
                  </TableCell>
                  <TableCell>{numberFormat(user.total_balance)}</TableCell>
                  <TableCell>{user.payment_method}</TableCell>
                  <TableCell>
                    {user.start_date === null ?"":moment(user.start_date).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell>
                    <Link to ={props.link =="regular"?`/regulardetails/${user.user_id}`:props.link =="target"?`/target_details/${user.id}`:props.link =="wallet"?`/wallet_details/${user.id}`:`/savetoloan_details/${user.user_id}`}>
                      <Button color="primary" variant="contained" > Details</Button>
                    </Link>
                  </TableCell>
                </TableRow>
              )):
              <TableRow>
              <TableCell colSpan="6" style={{textAlign:"center"}}>
                  No Record Found
                </TableCell>                
              </TableRow>
              }
            </TableBody>
           </Table>:
           type === "transaction"?
           <Table>
             <TableHead>
               <TableRow>
                 <TableCell>Name</TableCell>
                 <TableCell>Amount</TableCell>
                 <TableCell>Package</TableCell>
                 <TableCell>Status</TableCell>
                 <TableCell>Email</TableCell>
                 <TableCell>Created Date</TableCell>
                 <TableCell>Action</TableCell>
               </TableRow>
             </TableHead>
             <TableBody>
             {loading?
             <TableRow><TableCell><CircularProgress /></TableCell></TableRow>:
              users && users?.length !== 0 ?
              users?.map(user => (
               <TableRow
                 className={classes.tableRow}
                 hover
                 key={user.id}>
                 <TableCell>
                   <div className={classes.nameContainer}>
                     <Avatar
                       className={classes.avatar}
                       src={user.profile_pic}
                     >
                       {getInitials(user.first_name)}
                     </Avatar>
                     <Typography variant="body1">{user.first_name}{' '}{user.last_name}</Typography>
                   </div>
                 </TableCell>
                 <TableCell>{numberFormat(user.amount)}</TableCell>
                 <TableCell>{user.product_type}</TableCell>
                 <TableCell><p className={`${user?.status === 'completed' ? 'text-green':'text-orange'}`}>{user.status}</p></TableCell>
                 <TableCell>{user.email}</TableCell>
                 <TableCell>
                   {moment(user.created_at).format('DD/MM/YYYY')}
                 </TableCell>
                 <TableCell>
                    <Button onClick={()=>reversePosting(user?.id)} color="primary" variant="contained" >Reverse</Button>
                 </TableCell>
               </TableRow>
             )):
             <TableRow>
             <TableCell colSpan="6" style={{textAlign:"center"}}>
                 No Record Found
               </TableCell>                
             </TableRow>
             }
           </TableBody>
          </Table>:
           <Table>
           <TableHead>
             <TableRow>
               <TableCell>Name</TableCell>
               <TableCell>Total Balance</TableCell>
               <TableCell colSpan="5" style={{textAlign:"center"}}>Auto Save</TableCell>
             </TableRow>
             <TableRow>
               <TableCell></TableCell>
               <TableCell></TableCell>
               <TableCell>{props.link =="target"?'Targeted Amount':'Amount'}</TableCell>
               <TableCell>Frequency</TableCell>
               <TableCell>Payment Method</TableCell>
               <TableCell>Start Date</TableCell>
               <TableCell>Action</TableCell>
             </TableRow>
           </TableHead>
           <TableBody>
           {loading?
           <TableRow><TableCell><CircularProgress /></TableCell></TableRow>:
           users && users.length !== 0 ?
           users.map(user => (
             <TableRow
               className={classes.tableRow}
               hover
               key={user.id}>
               <TableCell>
                 <div className={classes.nameContainer}>
                   <Avatar
                     className={classes.avatar}
                     src={user.profile_pic}
                   >
                     {getInitials(user.first_name)}
                   </Avatar>
                   <Typography variant="body1">{user.first_name}{' '}{user.last_name}</Typography>
                 </div>
               </TableCell>
               <TableCell>{numberFormat(user.total_balance)}</TableCell>
               <TableCell>{props.link =="target"? numberFormat(user.targeted_amount) : numberFormat(user.amount)}</TableCell>
               <TableCell>{user.frequency}</TableCell>
               <TableCell>{user.payment_method}</TableCell>
               <TableCell>
                 {user.start_date === null ?"":moment(user.start_date).format('DD/MM/YYYY')}
               </TableCell>
               <TableCell>
                 <Link to ={props.link =="regular"?`/regulardetails/${user.user_id}`:props.link =="target"?`/target_details/${user.id}`:`/savetoloan_details/${user.user_id}`}>
                   <Button color="primary" variant="contained" > Details</Button>
                 </Link>
               </TableCell>
             </TableRow>
           )):
           <TableRow>
           <TableCell colSpan="6" style={{textAlign:"center"}}>
               No Record Found
             </TableCell>                
           </TableRow>
           }
         </TableBody>
        </Table>}
          </div>
        </PerfectScrollbar>
      </CardContent>
      <Paginate pagination={props.pagination} fetch_prev_page={props.fetch_prev_page} fetch_next_page={props.fetch_next_page} fetch_page={props.fetch_page}/>
    </Card>
  );
};

UsersTable.propTypes = {
  className: PropTypes.string,
  users: PropTypes.array.isRequired
};

export default UsersTable;
